export default class CAJA1070RequestModel {}
